import { makeStyles, createStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) =>
  createStyles({
    floatInput: {
      textAlign: theme.direction === 'rtl' ? 'end' : 'start',
    },
  }),
);
